import React, { useState, useEffect } from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Add, Delete } from "../../Svg";
import { useSelector } from "react-redux";



const ViewVariantsCard = ({ setFieldValue, values }) => {

    const { atributes } = useSelector((state) => state.products);
    const attributeOptions = atributes?.attributeOptions || [];


    const [attributes, setAttributes] = useState([
        { type: "", values: [] },
    ]);



    useEffect(() => {
        if (values.attributes) {
            const formattedAttributes = Object.entries(values.attributes)?.map(([key, value]) => ({
                type: key,
                values: Array.isArray(value) ? value : []
            }));
            setAttributes(formattedAttributes.length ? formattedAttributes : [{ type: "", values: [] }]);
        }
    }, [values.attributes]);




  

   

    return (
        <div className={styles.formSection}>
            <div className={styles.card}>
                <h2 className={styles.addCatH2}>Attributes</h2>

                {attributes?.map((attr, index) => (
                    <div key={index} className={styles.variantContainer}>

                        <label className={styles.addCatLabel} style={{ width: "50%" }}>
                            Variation Type
                            <select
                                className={styles.addCatSelect}
                                value={attr.type}
                                disabled
                            >
                                <option value="">Select</option>
                                {attributeOptions?.map((option) => (
                                    <option key={option} value={option} disabled={attributes.some(a => a.type === option)}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </label>

                        <div style={{ display: "block", marginTop: 10, width: '50%' }} className={styles.addCatLabel}>
                            Variation Value
                            <div style={{ position: 'relative' }}>

                                <div
                                    className={styles.addCatSelect}
                                  
                                >
                                    {attr.values.length > 0 ? attr.values.join(", ") : "Select"}

                                </div>

                        
                            </div>


                        </div>


                        
                    </div>
                ))}


               
            </div>
        </div>
    );
};


export default ViewVariantsCard
